import { ECW_VISIT_HISTORY_FEATURE, NEXTGEN_APPOINTMENT_HISTORY_FEATURE } from '../../global/featureFlags';

// The EHRs whose Send to Chart drawer shows the selected patient's past visits,
// keyed by the schema's `emr`. Both endpoints answer in the same shape.
const SOURCES = {
  // ENG-3660. The lookup runs under the picked practice, so it waits for one.
  NextGen: {
    feature: NEXTGEN_APPOINTMENT_HISTORY_FEATURE,
    searchPath: '/api/v1/nextgen_appointments/search',
    needsLocation: true,
    visitNoun: 'kept appointments',
    description: 'Kept appointments in NextGen, newest first.',
  },
  // ENG-3952.
  ECW: {
    feature: ECW_VISIT_HISTORY_FEATURE,
    searchPath: '/api/v1/ecw_visits/search',
    needsLocation: false,
    visitNoun: 'attended visits',
    description: 'Attended office visits in eClinicalWorks, newest first.',
  },
};

const appointmentHistorySource = (emr) => (
  Object.prototype.hasOwnProperty.call(SOURCES, emr) ? SOURCES[emr] : null
);

export default appointmentHistorySource;
